import searchStore from '../../store/store';
import { action } from 'satcheljs/lib/legacy';
/**
 * Set the store value synchronously to prevent rendering issues
 * The search input box is bound to the searchText in the search store.
 * We should never call setSearchText asynchronously
 * @param text The search text to set
 */
export default action('setSearchText')(function setSearchText(text) {
    searchStore.searchText = text;
});
//# sourceMappingURL=setSearchText.js.map